<span
  translate="no"
		notranslate
  role="img"
		class="initials-avatar__initials mat-title-small notranslate"
  aria-label="benutzer initialien"
		translate="no">
  {{ this.initials() }}
</span>
